export enum GQLErrorCodeEnum {
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  ACTOR_SUSPENDED = 'ACTOR_SUSPENDED',
  TARGET_SUSPENDED = 'TARGET_SUSPENDED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  BANNED_EMAIL = 'BANNED_EMAIL',
  TOO_MANY_CALLS_ERROR = 'TOO_MANY_CALLS_ERROR',
  WARNING = 'WARNING',
  RECORD_NOT_FOUND = 'RECORD_NOT_FOUND',
}
